import api from '@/services/api'

export const getUser = userId => {
    try {
        return api.get(`/users/${userId}`, {
            params: {
                filter: 'id;name;occupation;picture;manager_id',
                with: 'subordinates;manager',
            },
        })
    } catch (e) {
        console.log(e)
    }
}

export const getUsers = params => {
    try {
        return api.get('/users', { params })
    } catch (e) {
        console.log(e)
    }
}

export const getTemplates = () => {
    try {
        return api.get('/templates?with=askings')
    } catch (e) {
        console.log(e)
    }
}

export const saveSendFeedback = async (evaluated_id, content, category) => {
    try {
        const resp = await api.post('/feedbacks/send?load=evaluated;answers', {
            evaluated_id,
            content,
            category,
            is_spontaneous: true,
        })
        return resp
    } catch (e) {
        console.log(e)
    }
}

export const saveRequestFeedback = async (valuer_id, askings, askings_ids) => {
    try {
        const resp = await api.post('/feedbacks/request?load=valuer;answers', {
            valuer_id,
            askings,
            askings_ids,
        })
        return resp
    } catch (e) {
        console.log(e)
    }
}
